import { render, staticRenderFns } from "./approvalAuthReviewPage.vue?vue&type=template&id=0a2befb4&scoped=true"
import script from "./approvalAuthReviewPage.vue?vue&type=script&lang=js"
export * from "./approvalAuthReviewPage.vue?vue&type=script&lang=js"
import style0 from "./approvalAuthReviewPage.vue?vue&type=style&index=0&id=0a2befb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2befb4",
  null
  
)

export default component.exports